export default __webpack_public_path__ + "static/media/sass.b8981f2f.svg";